import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncYoutubeToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncYoutubeToAppleMusic}
            sections={<PairSyncGuideContent sourceKey="youtube" destKey="appleMusic" />}
        />
    );
}
